import { memo } from 'react';
import { ArrowIcon } from '../../../misc/icons/Icons';
import PopupWrapper from './PopupWrapper';

// TODO: Make own component for news list (filter buttons)
const TableWrapper = ({ children, title = '', buttons = [], buttonsBottom = false }) => (
	<div className={`flex flex-col px-0 ${!buttonsBottom ? 'pt-2 pb-20' : 'py-12'}  sm:px-5 max-w-table`}>
		{!buttonsBottom && (
			<div className={`flex flex-col sm:flex-row flex-wrap items-end sm:items-center px-4 py-1 mb-2 gap-x-4 gap-y-2 sm:gap-x-8 sm:gap-y-4 sm:py-2 sm:px-0 ${!buttons.length ? 'h-6 sm:h-16' : ''} ${buttons.length > 1 ? 'justify-between sm:justify-end' : ' justify-end'}`}>
				{buttons.map((button) => <TableButton key={button.id} title={button.title} dynamicTitlePart={button.dynamicTitlePart ?? ''} handleClick={button.handleClick} popoverItems={button.popoverItems} />)}
			</div>
		)}

		{title && (
			<div className="flex justify-center w-full px-3 py-3 lg:px-5 lg:py-4">
				<h1 className="lg:font-light text-[1.4375rem] lg:text-[1.875rem] text-oly-gray-darkest lg:leading-10">
					{title}
				</h1>
			</div>
		)}
		{children}
		{buttonsBottom && (
			<div className="flex flex-col justify-center px-4 pt-8 mb-2 sm:flex-row sm:items-center gap-x-4 gap-y-2 sm:gap-x-8 sm:gap-y-4 sm:pt-8 sm:px-0">
				{buttons.map((button) => <TableButton key={button.id} title={button.title} dynamicTitlePart={button.dynamicTitlePart ?? ''} handleClick={button.handleClick} popoverItems={button.popoverItems} />)}
			</div>
		)}
	</div>
);

const TableButton = ({ title, dynamicTitlePart = '', handleClick = null, popoverItems = []}) => {
	const buttonClasses = 'flex items-center px-4 py-2.5 font-semibold text-[0.875rem] sm:text-[1.0625rem] leading-5 sm:leading-7 text-white group bg-oly-blue-default can-hover:hover:bg-oly-blue-default-dark focus-visible:bg-oly-blue-default-dark focus:outline-none';
	const buttonTitle = title + dynamicTitlePart;

	const getButtonTitleMinWidth = () => {
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d');
		context.font = 'bold 17px sans-serif';
		return context.measureText(title).width + 40;
	};

	if (handleClick && !popoverItems.length) {
		return (
			<button
				type="button"
				onClick={handleClick}
				className={`${buttonClasses} text-left min-w-[12rem] justify-center`}
				aria-labelledby={buttonTitle}
			>
				{buttonTitle}
			</button>
		);
	}
	if (!handleClick && popoverItems.length) {
		return (
			<PopupWrapper
				button={(
					<div className={`${buttonClasses} text-left justify-between`}>
						<span style={{ minWidth: `${getButtonTitleMinWidth()}px` }}>{buttonTitle}</span>
						<ArrowIcon className="self-center w-5 h-5 ml-2 duration-300 transform rotate-0" />
					</div>
				)}
				items={popoverItems}
				width="w-48 sm:w-64"
				maxHeight="max-h-table-popover"
				placement="bottom"
				skidding={0}
				distance={24}
			/>
		);
	}
	return (
		<></>
	);
};

// TODO: Wann immer memo?
export default memo(TableWrapper);
